import React, { Component } from 'react';
import { InputNumber, Icon, message } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';

class EditAcTableCell extends Component {
    state = {
        edit: false,
    }

    edit = (edit) => {
        const { text, saveCellEdit, colNum } = this.props;
        this.setState({
            edit,
            newText: Number(text),
        }, () => {
            saveCellEdit(`fteValue${colNum}isEdit`, edit);
        });
    }

    save = () => {
        const { newText } = this.state;
        const { record, colNum, invId, loadData } = this.props;
        const { ftes = [] } = record;
        const options = {
            method: 'POST',
            url: `${API_URL.sumtotal.setInvestigationAcValue}`,
            data: {
                acValue: newText||0,
                investigationId: invId,
                title: ftes[colNum].title,
                investigationAcValueId: ftes[colNum].investigationAcValueId,
            },
            dateType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.edit(false);
                loadData();
            }
        }
        $.sendRequest(options)
    }

    handleInputNumberChange = (value) => {
        this.setState({ newText: value });
    }

    render() {
        const { edit, newText } = this.state;
        const { text } = this.props;
        return (
            <div>
                {
                    !edit ?
                        <div style={{ cursor: 'pointer' }} onClick={() => this.edit(true)}>{text}</div>
                    :
                        <div>
                            <InputNumber
                                defaultValue={newText}
                                precision={2}
                                onChange={this.handleInputNumberChange}
                            />
                            <Icon
                                style={{
                                    marginLeft: 4,
                                    cursor: 'pointer',
                                    color: '#75FE7B',
                                }}
                                type="check"
                                onClick={this.save}
                            />
                            <Icon
                                style={{
                                    marginLeft: 4,
                                    cursor: 'pointer',
                                    color: '#F00',
                                }}
                                type="rollback"
                                onClick={() => this.edit(false)}
                            />
                        </div>
                }
            </div>
        )
    }
}

export default EditAcTableCell;


// WEBPACK FOOTER //
// ./src/components/sumTotal/EditAcTableCell.js